module.exports = __webpack_public_path__ + "static/media/Human_ZG4577-Edit_1440.218ab677.jpeg";